import React from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import {shallowEqual, useSelector} from "react-redux";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./Admin/modules/Auth";
import ErrorsPage from "./Admin/modules/ErrorsExamples/ErrorsPage";
import Cookies from "universal-cookie";
import AdminBasePage from "./AdminBasePage";
import SuperAdminBasePage from "./SuperAdminBasePage";
import ResultManagerBasePage from "./ResultManagerBasePage";
import {
    ADMIN_ROLE,
    ADMIN_URL,
    RESULT_MANAGER_ROLE,
    SUPER_ADMIN_ROLE, SUPERVISOR_ROLE
} from "../enums/constant";

export function Routes() {

  const { isAuthorized = false, user } = useSelector(
    ({ auth }) => {
      const cookies = new Cookies();
      const accessToken = cookies.get("access_token");
      const tokenType = cookies.get("token_type");

      return {
        // Consider the user authorized if tokens exist; user info may still be loading
        isAuthorized: Boolean(accessToken && tokenType),
        user: auth.user
      };
    },
    shallowEqual
  );

  // Safely determine current role (may be undefined while user loads)
  const currentRole = user && Array.isArray(user.roles) && user.roles.length > 0 ? user.roles[0]?.role : undefined;

  return (
    <Switch>
      {!isAuthorized && (
        <Route>
          <AuthPage />
        </Route>
      )}
      <Route path="/error" component={ErrorsPage} />
      <Route path="/logout" component={Logout} />
      <Route path="/auth/login" render={({ location }) => {
        const cookies = new Cookies();
        const accessToken = cookies.get("access_token");
        const tokenType = cookies.get("token_type");
        if (accessToken && tokenType) {
          // If tokens exist, redirect to dashboard or last page
          // Use safe role access
          return <Redirect to={(currentRole === ADMIN_ROLE || currentRole === SUPERVISOR_ROLE) ? "/admin/dashboard" : currentRole === SUPER_ADMIN_ROLE ? "/superadmin/dashboard" : currentRole === RESULT_MANAGER_ROLE ? "/resultmanager/dashboard" : "/"} />;
        }
        return <AuthPage />;
      }} />
      <Redirect exact from="/" to="/auth/login" />
      <Redirect
        exact
        from={ADMIN_URL + "/subscriptions"}
        to={ADMIN_URL + "/subscriptions/deployedJobsPage"}
      />
      {!isAuthorized ? (
        user?.company ? (
          <Redirect to="/auth/user-registration" />
        ) : (
          <Redirect to="/auth/login" />
        )
      ) : (
        <Layout>
          {currentRole === ADMIN_ROLE ? (
            <AdminBasePage />
          ) : currentRole === SUPER_ADMIN_ROLE ? (
            <SuperAdminBasePage />
          ) : currentRole === RESULT_MANAGER_ROLE ? (
            <ResultManagerBasePage />
          ) : (
            // If role not yet known, keep base layout without redirect
            <BasePage />
          )}
        </Layout>
      )}
    </Switch>
  );
}
